import { GetPasswordParameters, PasswordConfiguration } from "../models/parametrizacion-api.model"


export function adaptPasswordParametrizationConfiguration(value: GetPasswordParameters): PasswordConfiguration {
  return {
    urlValidation: value.vigenciaUrl,
    numbersOfAttemps: value.numIntentos,
    waitingTime: value.tiempEspera,
    numbersOfCycles: value.cantCiclos,
    passwordRenewalFrequency: value.frecuCambioPass,
    maxAttempsMesage: value.mensajeMaxIntentos,
    blockedUserMessage: value.mensajeUsuarioBloqueo,
    passwordRecoveryInstructions: value.instRecuPassword,
    unauthorizedUserMessage: value.usuarioNoEncontrado,
    loggedUserMessage: value.mensajeUsuarioLogueado
  }
}

export function adaptPasswordParametrizationConfigurationToPayload(value: PasswordConfiguration): Omit<GetPasswordParameters, 'idAgente'> {
  return {
    numIntentos: value.numbersOfAttemps,
    tiempEspera: value.waitingTime,
    cantCiclos: value.numbersOfCycles,
    frecuCambioPass: value.passwordRenewalFrequency,
    vigenciaUrl: value.urlValidation,
    mensajeMaxIntentos: value.maxAttempsMesage,
    mensajeUsuarioBloqueo: value.blockedUserMessage,
    mensajeUsuarioLogueado: value.loggedUserMessage,
    usuarioNoEncontrado: value.unauthorizedUserMessage,
    instRecuPassword: value.passwordRecoveryInstructions,
  }
}
